import { Box, Text, Button } from "@chakra-ui/react";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import useVincularUnidadeGrupo from "core/features/grupo-unidades/hooks/useVincularUnidadeGrupo";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import FooterModal from "ui/components/Button/FooterModal";
import Field from "ui/components/Input/Field";
import SelectUnidade from "ui/components/Input/SelectUnidade";
import TabelaExemploExcelGrupoUnidade from "ui/components/Input/SelectGrupoUnidade/TabelaExemploExcelGrupoUnidade";
import InputFile from "components/Input/InputFile";
import excelToJson from "infra/helpers/excelToJson";
import { ImportarExcelGrupoUnidadeItem } from "core/features/grupo-unidades/typings";
import { MdCloudDownload } from "react-icons/md";
import { exportExcelExemploGrupoUnidades } from "core/features/grupo-unidades/helper";
interface FormVincularUnidadeProps {
  idGrupo: string;
  visible?: boolean;
  onClose?: () => any;
  onSuccess?: () => any;
}

function FormVincularUnidade({
  idGrupo,
  visible,
  onClose,
  onSuccess,
}: FormVincularUnidadeProps) {
  const { tenant } = useCurrentTenant();
  const { mutate: vincularUnidade, isLoading } =
    useVincularUnidadeGrupo(idGrupo);
  const { control, handleSubmit, reset, formState, watch } = useForm<{
    unidades: string[];
    excel: any;
  }>({
    reValidateMode: "onChange",
    mode: "onChange",
  });

  useEffect(() => {
    if (visible) {
      reset({});
    }
  }, [reset, visible]);

  const onSubmit = async (data: { unidades?: string[]; excel?: File }) => {
    let unidadesExcel: ImportarExcelGrupoUnidadeItem[] = [];
    if (data.excel) {
      unidadesExcel = await excelToJson<
        ImportarExcelGrupoUnidadeItem & { index: string },
        keyof ImportarExcelGrupoUnidadeItem
      >(data.excel);
    }

    vincularUnidade(
      { unidades: data.unidades, unidadesExcel },
      {
        onSuccess: (res) => {
          const successMessage = `${res.data.numeroUnidadesImportadas} ${
            res.data.numeroUnidadesImportadas === 1
              ? "unidade vinculada"
              : "unidades vinculadas"
          }`;

          onSuccess?.();
          showSuccess(successMessage).then(() => {
            onClose?.();
          });
        },
        onError: (e) => {
          showErrorAxios(e);
        },
      }
    );
  };

  const form = watch();

  return (
    <form onSubmit={(ev) => handleSubmit(onSubmit)(ev)}>
      <Text as="h3" fontSize={16} fontWeight="500" mb={4}>
        Vincular unidade ao grupo
      </Text>
      <Box>
        <Field
          label="Unidades"
          control={control}
          name="unidades"
          rules={{
            required: !form.excel,
          }}
          render={({ field }) => (
            <SelectUnidade
              tenantId={tenant.id}
              value={field.value}
              onChange={field.onChange}
              mode="multiple"
            />
          )}
        />
      </Box>

      <Box display="flex" gridGap={2} my={5}>
        <Box>
          <Field
            control={control}
            name="excel"
            rules={{
              required: !form.unidades?.length,
            }}
            render={({ field }) => (
              <InputFile
                onChange={field.onChange}
                label="Importar Excel"
                name={field.value?.name}
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                value={field.value}
                showPreview={false}
              />
            )}
          />
        </Box>

        <Button
          leftIcon={<MdCloudDownload fontSize={16} />}
          iconSpacing={2}
          bg="green.500"
          color="white"
          _hover={{
            bg: "green.400",
          }}
          fontSize={14}
          onClick={exportExcelExemploGrupoUnidades}
        >
          Baixar modelo de Planilha
        </Button>
      </Box>

      <TabelaExemploExcelGrupoUnidade />

      <FooterModal
        showRegisterAnother={false}
        isDisabled={!formState.isValid || isLoading}
        isLoadingSave={isLoading}
        onSubmit={handleSubmit(onSubmit)}
        onClose={onClose}
      />
    </form>
  );
}

export default FormVincularUnidade;
